import { render, staticRenderFns } from "./TabelaGridPadrao.vue?vue&type=template&id=9952bb68&"
import script from "./TabelaGridPadrao.vue?vue&type=script&lang=js&"
export * from "./TabelaGridPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports